import { createSelector } from 'reselect'


const giroNegocio = (state, props) => state.dataPymes.girosNegocio
const getCodigo = (state, props) => props.codGiroNegocio

export const nombreGiroNegocio = createSelector(
  giroNegocio,
  getCodigo,
  (lista, codigo) => lista.find((item) => item.giroCodigo === codigo).giroNombre
)



export const dataCoberturas = (state, props) => {
  const lista = state.dataPymes.maxCoberturas
  const codigo = props.idCobertura
  return lista[codigo]
}